import aylinPic from "@/public/images/artists/aylin.png";
import { Artist } from "@/types/types";

export const aylin = {
  id: "219",
  name: "Aylin",
  image: aylinPic,
  description: `Aylin's sound is light and breathy, with a unique mix of softness and depth. Her clear, understated falsetto and natural fluidity blend pop sensibility with an easy, laid-back energy.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Faylin-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Pop", "Dance", "RnB", "Unprocessed", "Falsetto"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "High",
        high: "Very high",
      },
      specific: {
        low: 55,
        high: 73,
      },
      sweetSpot: 62,
    },
  },
} as const satisfies Artist;
